import { useEffect } from 'react';
import useLoginStore from '@stores/login/loginStore';
import {
  getIsPartialUser,
  getIsPhoneVerified,
  getIsRegistered,
  getLoginMethod,
  getOtpOrEmailResponse
} from '@stores/selectors/login';
import constants, {
  LOGIN_METHOD_EMAIL_OTP,
  LOGIN_METHOD_EMAIL_PHONE_OTP
} from '../../constants';

const useLoginStepSetter = ({
  loginType,
  accountType,
  setStep,
  setNumberStepErrorMsg
}) => {
  const loginMethod = useLoginStore(getLoginMethod);
  const otpOrEmailResponse = useLoginStore(getOtpOrEmailResponse);
  const isRegistered = useLoginStore(getIsRegistered);
  const isPartialUser = useLoginStore(getIsPartialUser);
  const isPhoneVerified = useLoginStore(getIsPhoneVerified);

  useEffect(() => {
    if (otpOrEmailResponse) {
      let errorMsg = '';
      if (otpOrEmailResponse.error) errorMsg = otpOrEmailResponse.error.message;
      if (errorMsg === '') {
        if (loginType === constants.LOGIN_TYPE_EMAIL) {
          if (
            loginMethod === LOGIN_METHOD_EMAIL_OTP ||
            loginMethod === LOGIN_METHOD_EMAIL_PHONE_OTP
          ) {
            setStep(constants.ENTER_OTP_STEP);
          } else setStep(constants.ENTER_PASSWORD_STEP);
        } else if (isRegistered && isPartialUser) {
          setStep(constants.ENTER_OTP_UNREGISTERED_USER_STEP);
        } else if (isRegistered) {
          setStep(constants.ENTER_OTP_STEP);
        }
      } else {
        setNumberStepErrorMsg(errorMsg);
      }
    }
  }, [
    otpOrEmailResponse,
    isPartialUser,
    setStep,
    setNumberStepErrorMsg,
    isPhoneVerified,
    isRegistered,
    accountType,
    loginType,
    loginMethod
  ]);
};

export default useLoginStepSetter;
